export default __webpack_public_path__ + "static/media/caret.59c78c8b.svg";